import templateHelpers from './template-helpers'
import render from './trigger-editor.pug'
import ACTIONS, { checkConflict as checkActionConflict } from './actions'
import CONDITIONS from './trigger-editor/conditions'
import EditorBase from './editor-base'

export default class TriggerEditor extends EditorBase
  @ACTIONS: ACTIONS
  @CONDITIONS: CONDITIONS

  constructor: ({trigger, sceneEditor, initial=false})->
    super()

    @trigger = trigger
    @sceneEditor = sceneEditor
    @initial = initial
    @trigger.actions ||= {}
    @actionEditorsByType = {}

    unless @initial
      @conditionEditor = @_buildConditionEditor()

  @property "actions", get: -> @trigger.actions ||= {}

  @property "label", get: ->
    return @t('.initial_label') if @initial

    conditionClass = @constructor.CONDITIONS[@trigger.type]
    conditionClass?.label || @trigger.type

  @property "breadcrumbLabel", get: ->
    return @label if @initial

    @trigger._name || @label

  @property "configuredActions", get: ->
    @_syncActionForms()

    menu = []
    for actionType of @actions
      if definition = @constructor.ACTIONS[actionType]
        menu.push({type: actionType, label: definition.label, icon: definition.icon})
      else
        menu.push(
          type: actionType
          label: @t('.unsupported_action', type: actionType)
          unsupported: true
        )

    menu

  @property "availableActions", get: ->
    compatible = []
    incompatible = []
    configuredActionTypes = Object.keys(@actions)

    for actionType, definition of @constructor.ACTIONS
      continue if @actions[actionType]

      conflict = checkActionConflict(configuredActionTypes, actionType)
      menuToAdd = if conflict then incompatible else compatible

      menuToAdd.push({type: actionType, label: definition.label, icon: definition.icon, conflict})

    compatible.concat incompatible

  bindElement: (@element)=>

  addAction: (menuEntry, e)=>
    return if menuEntry.conflict

    @actions[menuEntry.type] ||= {}
    @actionEditorFor(menuEntry.type)
    @sceneEditor.projector.scheduleRender()

    e.target.blur() if e

  deleteAction: (actionType)=>
    label = @constructor.ACTIONS[actionType]?.label || actionType
    return unless confirm(@t('.confirm_delete', label: label))

    delete @actions[actionType]
    delete @actionEditorsByType[actionType]
    @sceneEditor.projector.scheduleRender()

  deleteTrigger: =>
    @sceneEditor.deleteTrigger(@trigger)

  actionEditorFor: (actionType)->
    return null unless actionClass = @constructor.ACTIONS[actionType]

    actionStore = @actions[actionType] ||= {}
    actionEditor = @actionEditorsByType[actionType]

    unless actionEditor?.store == actionStore
      actionEditor = new actionClass(actionStore, editor: this)
      @actionEditorsByType[actionType] = actionEditor

    actionEditor

  save: =>
    await @conditionEditor?.save()

    @_syncActionForms()
    for actionType, actionEditor of @actionEditorsByType
      continue unless @actions[actionType]

      await actionEditor.save()

  render: =>
    @_syncActionForms()
    render.call(this, templateHelpers)[0]

  _buildConditionEditor: ->
    unless conditionClass = @constructor.CONDITIONS[@trigger.type]
      console.error("Trigger condition type not supported: #{@trigger.type}")
      return null

    conditionEditor = new conditionClass(@trigger, editor: @sceneEditor)
    conditionEditor.inline = true
    conditionEditor

  _syncActionForms: ->
    for actionType of @actionEditorsByType
      delete @actionEditorsByType[actionType] unless @actions[actionType]

    for actionType of @actions
      @actionEditorFor(actionType)
